var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLight5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "#EAFCFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1280_130614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2812 33.6328C16.0118 33.6328 10.0977 39.547 10.0977 46.8164C10.0977 54.0858 16.0118 60 23.2812 60C30.5507 60 36.4648 54.0858 36.4648 46.8164C36.4648 39.547 30.5507 33.6328 23.2812 33.6328ZM29.1021 45.2154L22.2662 52.0514C21.9803 52.3374 21.6054 52.4805 21.2305 52.4805C20.8556 52.4805 20.4807 52.3374 20.1947 52.0514L17.265 49.1217C16.693 48.5497 16.693 47.6222 17.265 47.0501C17.837 46.4781 18.7646 46.4781 19.3366 47.0501L21.2305 48.944L27.0307 43.1438C27.6026 42.5719 28.5302 42.5719 29.1022 43.1438C29.6742 43.7159 29.6742 44.6435 29.1021 45.2154Z",
    fill: "#009999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6719 22.6953C47.8629 22.6953 47.207 22.0395 47.207 21.2305V10H26.2109C23.7878 10 21.8164 11.9714 21.8164 14.3945V30.7704C22.299 30.7267 22.7874 30.7031 23.2812 30.7031C28.2742 30.7031 32.7438 32.9859 35.7018 36.5625H51.6016C52.4105 36.5625 53.0664 37.2184 53.0664 38.0273C53.0664 38.8363 52.4105 39.4922 51.6016 39.4922H37.6316C38.5473 41.2789 39.1377 43.2583 39.3272 45.3516H51.6016C52.4105 45.3516 53.0664 46.0074 53.0664 46.8164C53.0664 47.6254 52.4105 48.2812 51.6016 48.2812H39.3272C38.8892 53.119 36.3044 57.3463 32.535 60H55.5078C57.931 60 59.9023 58.0286 59.9023 55.6055V22.6953H48.6719ZM51.6016 30.7031H30.1172C29.3082 30.7031 28.6523 30.0473 28.6523 29.2383C28.6523 28.4293 29.3082 27.7734 30.1172 27.7734H51.6016C52.4105 27.7734 53.0664 28.4293 53.0664 29.2383C53.0664 30.0473 52.4105 30.7031 51.6016 30.7031Z",
    fill: "#009999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1367 10.8574V19.7653H59.044L50.1367 10.8574Z",
    fill: "#009999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1280_130614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight5);
export default __webpack_public_path__ + "static/media/Icon-light-5.3d6dc0cd548d8b5f1b9ddaa30804befa.svg";
export { ForwardRef as ReactComponent };